<template>
  <div class="all-container">
    <div class="tr-main-header">
      <yj-trip-type :tripType="tripType" :vipParams="vipParams" @changeTripType="changeTripType">
      </yj-trip-type>
      <yj-travel-apply :proType="10903" :ccsqdNoOrId="htCnCcsqD.ccsqdId || htCnCcsqD.ccsqdNo"
        :routeId="htCnCcsqD.routeId" v-if="tripType == 1 && bookStyle == 2" @chooseTravelApply="chooseTravelApply"
        :showCityDesc="false"></yj-travel-apply>
      <el-input v-model="cxrName" v-if="(bookStyle == 1 && tripType == 1) || tripType == 2" class="tr-input"
        @click.native="selectCxrPop" readonly>
        <i slot="prefix" class="el-input__icon el-icon-user"></i>
      </el-input>
      <!-- <span v-if="cxrLength>1" @click="getCheckInPlan">调整入住方案</span> -->
    </div>
    <int-ht-search @searchHotel="searchHotel" @getHtClbz="getHtClbz" :loading="htLoading"
      :bookDateRange="bookDateRange"></int-ht-search>
    <!-- 单订模式 出行人-->
    <yj-cxr-list :visible="cxrShow" :cxrList="chooseCxrList" @chooseCxrList="selectCxrCallback" :proType="10903"
      @cancleCxrList="cancelCXR"></yj-cxr-list>
  </div>
</template>

<script>
import {
  mapGetters, mapMutations, mapState
} from 'vuex';
import mixin from './../../../mixin';
import intHtSearch from './intHtSearch';
import { handleIntHotelRoom } from '../../../hooks/useHotel';

export default {
  name: 'inthtCnQueryCard',
  mixins: [mixin.ccsqdMixin],
  data() {
    return {
      cxrShow: false, // 显示出行人
      cxrLength: 0, // 多少出行人
      planShow: false, // 调整入住方案
      htLoading: false,
    }
  },
  components: {
    intHtSearch,
    // roomDrag: roomDrag,
  },
  computed: {
    ...mapState({
      htCnQuery: (state) => state.intHt.htCnQuery, //
      htCnCcsqD: (state) => state.intHt.htCnCcsqD,
      ccsqdInfo: (state) => state.common.ccsqdInfo, // 出差申请单信息
      htCnParams: (state) => state.intHt.htCnParams,
      htCnSonTags: (state) => state.intHt.htCnSonTags,
      htCnPolicy: (state) => state.intHt.htCnPolicy,
      cxrList: state => state.intHt.cxrList, // 因公出行人
      ysCxrList: state => state.intHt.ysCxrList, // 因私出行人
    }),
    ...mapGetters({
      roomEmpMap: 'intHt/roomEmpMap',
      getVipParamterByParNo: 'common/getVipParamterByParNo',
    }),
    // 日期最小，和最大值对象
    bookDateRange() {
      // 方法来自于mixins
      let dateRangeObj = this.getBookDateRange(10903, this.htCnQuery.tripType, 30, this.htCnCcsqD.ccsqdId, this.htCnCcsqD.routeId);
      return dateRangeObj
    },
    tripType() {
      /* 默认当前因公因私*/
      return this.htCnQuery.tripType //1为公 2为私
    },
    // 登录人信息
    userInfo() {
      let userInfo = this.$common.getUserInfo();
      return userInfo;
    },
    empInfo() {
      return this.userInfo.empInfo;
    },
    bookStyle() {
      // 1单订模式  2出差申请单模式
      let bookStyle = this.$common.getBookStyle(this.$store, 10903)
      return bookStyle
    },
    //因公因私参数控制
    vipParams() {
      let params = this.getVipParamterByParNo(20010, 3)
      return params;
    },
    gkfsRole() {
      return this.htCnQuery.gkfsRole
    },
    roomNum: {
      get() {
        return this.htCnParams.roomNum
      },
      set(val) {
        this.SET_HTCN_PARAMS({ roomNum: val })
      },
    },
    adultNum: {
      get() {
        return this.htCnParams.adultNum
      },
      set(val) {
        this.SET_HTCN_PARAMS({ adultNum: val })
      },
    },
    cxrName() {
      if (this.tripType == 2) {
        return (this.ysCxrList || []).map(item => item.empName).join(',');
      }
      return (this.cxrList || []).map(item => item.empName).join(',');
    },
    chooseCxrList() {
      if (this.tripType == 2) {
        return this.ysCxrList || [];
      }
      return (this.cxrList || []);
    }
  },
  mounted() {
    // 单订 因公模式下，默认登录人为出行人
    let isBs = this.tripType == 1;
    if (isBs) {
      if (this.cxrList.length == 0 && this.bookStyle == 1 && this.empInfo.opers && this.empInfo.opers.indexOf(3) < 0) {
        this.empInfo.useCardType = '1'; // 当前出行人使用证件类型  1 身份证  2 护照  3 港澳通行证   4 台胞证  5 回乡证  6 台湾通行证  7 学生证  8 军官证  9 其他证件
        this.empInfo.cxrType = '1'; //当前人的出行人类型   1.员工  2.常旅客 3. 其他
        this.empInfo.psgType = '1'; // 默认 1  1成人 2儿童 3婴儿 
        this.empInfo.cxrName = this.empInfo.empName; //当前出行人的中文名字
        // this.SET_CXR_LIST([this.empInfo])
        this.selectCxrCallback([this.empInfo])
      }
      if (this.bookStyle == 1) {
        this.getHtClbz();
      }
    } else {
      this.SET_YSCXR_LIST([this.empInfo])
    }

  },
  methods: {
    ...mapMutations({
      SET_HTCN_QUERY: 'intHt/SET_HTCN_QUERY', // 保存因共模式下的自定义信息
      SET_HTCN_PARAMS: 'intHt/SET_HTCN_PARAMS', // 设置查询参数
      SET_HTCN_CCSQD: 'intHt/SET_HTCN_CCSQD', //保存因共模式下的出差申请单信息
      SET_CCSQD_INFO: 'common/setCcsqdInfo', // 全局的出差申请单信息
      SET_HTCN_SONNTAGS: 'intHt/SET_HTCN_SONNTAGS',
      SET_HTCN_POLICY: 'intHt/SET_HTCN_POLICY',
      COPY_ROOMS: 'intHt/COPY_ROOMS',
      SET_CXR_LIST: 'intHt/SET_CXR_LIST',
      SET_YSCXR_LIST: 'intHt/SET_YSCXR_LIST',
      SET_STATE: 'intHt/SET_STATE',
    }),
    // 因公因私切换
    changeTripType(tripType) {//因公因私控制的时候，因公模式下使用出行人
      if (this.tripType == tripType) return;
      this.SET_HTCN_QUERY({
        tripType: tripType
      })
      let list = [];
      if (tripType == 2) {
        if (!this.ysCxrList || this.ysCxrList.length == 0) {
          this.empInfo.useCardType = '1'; // 当前出行人使用证件类型  1 身份证  2 护照  3 港澳通行证   4 台胞证  5 回乡证  6 台湾通行证  7 学生证  8 军官证  9 其他证件
          this.empInfo.cxrType = '1'; //当前人的出行人类型   1.员工  2.常旅客 3. 其他
          this.empInfo.psgType = '1'; // 默认 1  1成人 2儿童 3婴儿 
          this.empInfo.cxrName = this.empInfo.empName; //当前出行人的中文名字
          list = [this.empInfo]
        } else {
          list = this.$common.deepCopy(this.ysCxrList);
        }
      } else {
        list = this.$common.deepCopy(this.cxrList || [])
      }
      // 因公因私切换需要重新分配房间
      this.selectCxrCallback(list);
    },
    // 选中出差申请单
    chooseTravelApply(obj) {
      //选中的出差申请单
      let routeObj = obj?.currentRoute ?? {};

      //rw11486
      var startDate = this.$common.getNewDepartDate({
        departDate: routeObj.departDate || routeObj.routeStart,
        routeDateStart: routeObj.routeStart,
        routeDateEnd: routeObj.routeEnd
      });
      if (startDate === '0000-00-00') {
        this.$message({
          type: 'error',
          message: '出差行程已过期, 无法预订',
        })
        // return;
        //此处只做行程过期提示， 不在控制代码执行逻辑
        startDate = routeObj.departDate || routeObj.routeStart;
      }

      let cxrList = obj?.cxrList ?? [];
      let ccsqdInfo = obj?.detail; // 出差申请单所有信息

      this.SET_CCSQD_INFO({
        ccsqdInfo: ccsqdInfo,
      });
      this.SET_HTCN_CCSQD(this.$common.deepCopy(obj)); //不知道有啥参数后面要用啊 ，先直接全部深拷贝存一遍把
      this.SET_CXR_LIST(cxrList);
      // 当前出差申请单相关信息存储到vuex
      let queryobj = {
        checkInDate: startDate, //日期开始时间
        // checkOutDate: routeObj.arriveDate, // 日期结束时间
        keywords: routeObj?.flightNo ?? ''
      }

      queryobj.checkOutDate = routeObj.arriveDate <= queryobj.checkInDate ?
        this.$common.getDateMing(queryobj.checkInDate, 1) : routeObj.arriveDate;
      //如果离店日期超过了行程结束日期，那么将离店日期修改为行程默认的离店日期，由查询页判断入住离店日期是否可预订
      if (queryobj.checkOutDate > routeObj.routeEnd) {
        queryobj.checkOutDate = routeObj.arriveDate;
      }

      // 分配房间
      let adNum = this.adultNum;
      let num = this.roomNum;
      // 人数总量大于房间数*单个房间人数
      if (adNum * num < cxrList.length) {
        num = Math.ceil(cxrList.length / adNum);
      }
      let hotelRoom = handleIntHotelRoom({ preCxrList: cxrList, maxFjs: num, maxNums: adNum });
      this.SET_STATE({
        allRank: hotelRoom.allRank,
        rooms: hotelRoom.rooms,
        travelerIds: hotelRoom.travelerIds,
      })

      console.log('分配房间 === ', hotelRoom);
      if (hotelRoom.rooms && hotelRoom.rooms.length > 0) {
        adNum = hotelRoom.rooms[0].length ?? adNum;
      }
      this.adultNum = adNum;
      this.roomNum = hotelRoom.roomNum;
      let empObj = {
        empRank: hotelRoom.minEmpRank, //   职级
        // useNameclbz: hotelRoom.minEmpName, // 本次预订使用谁的差旅标准
      }
      this.$emit('useNameclbz', empObj.useNameclbz)
      this.$emit('chooseCcsqd', this.$common.deepCopy(obj))
      this.SET_HTCN_QUERY(empObj)
      this.SET_HTCN_PARAMS(queryobj);
      this.getHtClbz();
    },
    // 单订模式下出行人显示
    selectCxrPop(el) {
      this.cxrShow = true;
    },
    // 选中出行人 出行人默认是当前登录人
    selectCxrCallback(list) {
      // 是否因公
      let isBs = this.tripType == 1;
      // 分配房间
      let adNum = this.adultNum;
      let num = this.roomNum;
      if (num == 0) num = 1;
      // 人数总量大于房间数*单个房间人数
      if (adNum * num < this.cxrList.length) {
        num = Math.ceil(this.cxrList.length / adNum);
      }
      let hotelRoom = handleIntHotelRoom({ preCxrList: list, maxFjs: num, maxNums: adNum });
      this.SET_STATE({
        allRank: hotelRoom.allRank,
        rooms: hotelRoom.rooms,
        travelerIds: hotelRoom.travelerIds,
      })
      let empObj = {
        empRank: hotelRoom.minEmpRank, //   职级
        useNameclbz: hotelRoom.minEmpName, // 本次预订使用谁的差旅标准
      }
      if (hotelRoom.rooms && hotelRoom.rooms.length > 0) {
        adNum = hotelRoom.rooms[0].length ?? adNum;
      }
      this.adultNum = adNum;

      this.roomNum = hotelRoom.roomNum || 1;
      this.SET_HTCN_QUERY(empObj)
      this.cxrShow = false;
      if (isBs) {
        this.SET_CXR_LIST(list);
        this.getHtClbz();
      } else {
        this.SET_YSCXR_LIST(list);
      }
    },
    // 获取员工 差旅信息
    getRank() {
      // 获取最低员工职级
      let minEmp = this.$common.getMinEmpRank(this.cxrList);
      let queryObj = {
        'empRank': minEmp.empRank || 0, //   职级
        'useNameclbz': minEmp.cxrName || minEmp.empName, // 本次预订使用谁的差旅标准
        'minEmpRankEmpId': minEmp.empId, // 当前员工差旅标准的职级
      }
      this.$emit('useNameclbz', queryObj.useNameclbz)
      this.SET_HTCN_QUERY(queryObj)
    },
    // 取消出行人
    cancelCXR(bool) {
      this.cxrShow = bool;
    },
    // 所搜酒店数据
    searchHotel() {
      if (this.tripType == 1 && this.bookStyle == 1) {
        if (this.cxrName == 0) {
          this.$message.warning('请选择出行人')
          return
        }
      }
      // 重新搜索到第一页
      this.SET_HTCN_PARAMS({
        pageNum: 1,
      })
      // this.getHtClbz();
      this.$emit('queryHtCn', true)
    },
    // 单订模式下 因公匹配差旅标准
    getHtClbz() {
      if (!this.htCnParams.cityId || this.tripType == 2) return;
      let nowDays = this.$moment().format("YYYY-MM-DD")
      let nextDays = this.$moment().add(1, "days").format("YYYY-MM-DD")
      let params = {
        cityId: this.htCnParams.cityId, //城市或者商圈id
        dateStart: this.htCnParams.checkInDate || nowDays, //日期开始时间
        dateEnd: this.htCnParams.checkOutDate || nextDays, // 日期结束时间
        ccsqdId: this.htCnCcsqD.ccsqdId,
        routeId: this.htCnCcsqD.routeId,
        tripType: 1,
        roomEmpMap: this.roomEmpMap,
      }
      let userInfo = this.$common.getUserInfo();
      params.corpId = userInfo.empInfo.corpId;
      this.$conn.getConn('htbook.interHotelTravelPolicyDetail')(params, (res) => {
        let data = res.data || {};
        let policy = data.policy || {};
        let policyInfo = { policy };
        // this.getRank()
        this.SET_HTCN_POLICY(this.$common.deepCopy(policyInfo))
      })
    }

  }

}
</script>

<style lang="scss" scoped>
.all-container {
  width: 1200px;
  margin: 0 auto;

  .tr-main-header {
    text-align: left;
    margin-top: 18px;
    line-height: 30px;
    min-height: 32px;
    display: flex;

    .el-input {
      width: 200px;
      margin-left: 20px;
    }

    .tr-input {

      /deep/ .el-input__inner {
        width: 200px;
        height: 34px;
        line-height: 34px;
      }
    }
  }
}
</style>
